export const TRACKING_STRINGS = {
  eventNames: {
    'initial-pricing-estimate': 'initial_pricing_estimate_completed',
    splash_screen_viewed: 'splash_screen_viewed',
  },
};
